import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

function readJson(key: string): any | null {
  const raw = localStorage.getItem(key);

  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function decodeJwtPayload(token: string): any | null {
  try {
    const payload = token.split('.')[1];

    if (!payload) return null;

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(
      base64.length + (4 - (base64.length % 4)) % 4,
      '='
    );

    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

function getRole(): string {
  const auth =
    readJson('auth') ||
    readJson('user') ||
    readJson('usuario') ||
    readJson('currentUser');

  const token =
    localStorage.getItem('token') ||
    localStorage.getItem('access_token') ||
    localStorage.getItem('accessToken');

  const tokenData = token ? decodeJwtPayload(token) : null;

  const data = auth || tokenData;

  return String(
    data?.role ||
      data?.rol ||
      data?.Role ||
      data?.Rol ||
      data?.user?.role ||
      data?.user?.rol ||
      data?.usuario?.role ||
      data?.usuario?.rol ||
      localStorage.getItem('role') ||
      localStorage.getItem('rol') ||
      ''
  ).toLowerCase();
}

export const homeRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const role = getRole();

  if (role === 'vendedor') {
    return router.createUrlTree(['/pos']);
  }

  return router.createUrlTree(['/dashboard']);
};